import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <PageContainer>
      <StyledWrapper>
        <main className="my-custom-face-container">
          <svg className="face" viewBox="0 0 320 380">
            <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={25}>
              <g className="face__eyes" transform="translate(0,112.5)">
                <g transform="translate(15,0)">
                  <polyline className="face__eye-lid" points="37,0 0,120 75,120" />
                  <polyline className="face__pupil" points="55,120 55,155" strokeDasharray="35 35" />
                </g>
                <g transform="translate(230,0)">
                  <polyline className="face__eye-lid" points="37,0 0,120 75,120" />
                  <polyline className="face__pupil" points="55,120 55,155" strokeDasharray="35 35" />
                </g>
              </g>
              <rect className="face__nose" x="132.5" y="112.5" width={55} height={155} rx={4} ry={4} />
              <g transform="translate(65,334)" strokeDasharray="102 102">
                <path className="face__mouth-left" d="M 0 30 C 0 30 40 0 95 0" />
                <path className="face__mouth-right" d="M 95 0 C 150 0 190 30 190 30" />
              </g>
            </g>
          </svg>
        </main>
      </StyledWrapper>
      <Link to="/" className="home-link">Go to Homepage</Link>
    </PageContainer>
  );
}

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: #f8f9fa; /* Matches the overall light theme nicely if any */

  .home-link {
    display: inline-block;
    padding: 10px 20px;
    margin-top: 20px;
    background-color: #0d6efd;
    color: white;
    text-decoration: none;
    border-radius: 5px;
    font-weight: bold;
    transition: background-color 0.3s;
  }

  .home-link:hover {
    background-color: #0b5ed7;
    color: white;
  }
`;

const StyledWrapper = styled.div`
  .my-custom-face-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 500px;
    background: #ffffff00;
    color: #1a1a1a;
  }

  .my-custom-face-container .face {
    width: 400px;
  }

  .my-custom-face-container .face__eyes,
  .my-custom-face-container .face__eye-lid,
  .my-custom-face-container .face__mouth-left,
  .my-custom-face-container .face__mouth-right,
  .my-custom-face-container .face__nose,
  .my-custom-face-container .face__pupil {
    animation: eyes 1s 0.3s forwards;
  }

  .my-custom-face-container .face__eye-lid,
  .my-custom-face-container .face__pupil {
    animation-duration: 4s;
    animation-delay: 1.3s;
    animation-iteration-count: infinite;
  }

  .my-custom-face-container .face__eye-lid {
    animation-name: eye-lid;
  }
  .my-custom-face-container .face__mouth-left {
    animation-name: mouth-left;
  }
  .my-custom-face-container .face__mouth-right {
    animation-name: mouth-right;
  }
  .my-custom-face-container .face__nose {
    animation-name: nose;
  }
  .my-custom-face-container .face__pupil {
    animation-name: pupil;
  }

  @keyframes eye-lid {
    0%,
    40%,
    45%,
    100% {
      transform: translateY(0);
    }
    42.5% {
      transform: translateY(17.5px);
    }
  }

  @keyframes eyes {
    from {
      transform: translateY(112.5px);
    }
    to {
      transform: translateY(15px);
    }
  }

  @keyframes pupil {
    0%,
    37.5%,
    40%,
    45%,
    87.5%,
    100% {
      stroke-dashoffset: 0;
      transform: translate(0, 0);
    }
    12.5%,
    25%,
    62.5%,
    75% {
      transform: translate(-35px, 0);
    }
    42.5% {
      stroke-dashoffset: 35;
      transform: translate(0, 17.5px);
    }
  }

  @keyframes mouth-left {
    from,
    50% {
      stroke-dashoffset: -102;
    }
    to {
      stroke-dashoffset: 0;
    }
  }

  @keyframes mouth-right {
    from,
    50% {
      stroke-dashoffset: 102;
    }
    to {
      stroke-dashoffset: 0;
    }
  }

  @keyframes nose {
    from {
      transform: translate(0, 0);
    }
    to {
      transform: translate(0, 22.5px);
    }
  }
`;

export default NotFound;
